/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {BatchGetOwnerPersonTokenRequest} from '@cash-web/protos/squareup/roster/mds.pb'
import {BatchGetOwnerPersonTokenResponse} from '@cash-web/protos/squareup/roster/mds.pb'


export const batchGetOwnerPersonToken = (request: BatchGetOwnerPersonTokenRequest, options?: CashRequestOptions) => post<BatchGetOwnerPersonTokenRequest, BatchGetOwnerPersonTokenResponse>("/2.0/cash/batch-get-owner-person-token", request, {...options, rejectOnError: true })